import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { isEmpty } from "lodash";
import moment from "moment";
import { Roles, RouteType } from "src/app/models/enum";
import { DateFormat } from "src/app/shared/constants/angular-datetime-picker.const";
import { RoleService } from "src/app/shared/services/role.service";
import { SharedService } from "src/app/shared/services/shared.service";

type User = {
	id: string;
	timeJoined: number;
	isPrimaryUser: boolean;
	tenantIds: string[];
	emails: string[];
	phoneNumbers: string[];
	thirdParty: {
		id: string;
		userId: string;
	}[];
	loginMethods: {
		tenantIds: string[];
		timeJoined: number;
		recipeId: "emailpassword" | "thirdparty" | "passwordless";
		recipeUserId: string;
		verified?: boolean;
		email?: string;
		phoneNumber?: string;
		thirdParty?: {
			id: string;
			userId: string;
		};
	}[];
};

@Component({
	selector: "app-dashboard",
	templateUrl: "./dashboard.component.html",
	styleUrls: ["./dashboard.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class DashboardComponent implements OnInit {
	currentDate: Date = new Date();
	userID: any;

	constructor(
		private sharedService: SharedService,
		public roleService: RoleService,
	) {}

	ngOnInit(): void {
		this.sharedService.setActivePage(RouteType.DASHBOARD);
		this.roleService.getAuthenticatedUser().subscribe((user: User) => {
			console.log(user);
			this.userID = user;
		});
		console.log(this.userID);
		console.log(this.roleService.userDetails);
	}

	get dateValue(): string {
		return moment(this.currentDate).format(DateFormat.datePickerDateFormat);
	}

	get role() {
		return Roles;
	}

	switchRole(role: string) {
		this.roleService.switchRole(role);
	}

	handleDateChange(dateString: string): void {
		if (!isEmpty(dateString)) {
			this.currentDate = new Date(dateString);
		}
	}
}
